const firebaseConfig = {
    apiKey: "AIzaSyAUOu0FdUhTmgzVLaft2PVoXzhJ2qUTw_c",
    authDomain: "beeid-5ab5e.firebaseapp.com",
    databaseURL: "https://beeid-5ab5e-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "beeid-5ab5e",
    storageBucket: "beeid-5ab5e.appspot.com",
    messagingSenderId: "575653704242",
    appId: "1:575653704242:web:16c85c4eeb394388bc022b",
    measurementId: "G-S1PK97JQ7B"
};

export default firebaseConfig;



// WEBPACK FOOTER //
// ./resources/build/js/custom/fireBase.js